import CountryService from "app/services/CountryService";
import type { ListRecommendationType, OpportunityListType } from "../../../types";
import { useDivideRecommendations } from "./hooks/divideRecommendations";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import type { RecommendationsListBaseProps } from "./RecommendationsList";
import RecommendationsList from "./RecommendationsList";

type RecommendationsContentProps = RecommendationsListBaseProps & {
    list: OpportunityListType;
    recommendations: ListRecommendationType[];
};

const RecommendationsContent = (props: RecommendationsContentProps) => {
    const { list, recommendations, ...recommendationsListProps } = props;

    const listCountry = CountryService.getCountryById(list.country);
    const worldwideCountryItem = CountryService.getCountryById(WORLDWIDE_COUNTRY_ID);

    const [similarRecommendation, worldwideRecommendation] = useDivideRecommendations(recommendations, listCountry?.id);

    return (
        <>
            {similarRecommendation.length > 0 && listCountry ? <RecommendationsList
                    recommendationsList={similarRecommendation}
                    country={listCountry}
                    {...recommendationsListProps}
                /> : null}
            {worldwideRecommendation.length > 0 ? <RecommendationsList
                    recommendationsList={worldwideRecommendation}
                    country={worldwideCountryItem}
                    {...recommendationsListProps}
                /> : null}
        </>
    );
};

export default RecommendationsContent;
